export default __webpack_public_path__ + "static/media/conversation-light.2a3c55e6.jpg";